var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rewards", class: _vm.columnStyle ? "-column" : "" },
    [
      _c("div", { staticClass: "first-info" }, [
        _c("img", {
          staticClass: "img",
          attrs: { src: _vm.coin.program_image }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.value))])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "name" }, [
        _vm._v(_vm._s(_vm.coin.program_name))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d15ebd2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d15ebd2e","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Engagement/Components/EngagementCoin.vue
// module id = 2080
// module chunks = 1610